// define a mixin object

export let FormMixin = {
  created: function () {
  },
  computed: {
    isCreating() {
      if(!this.formData) {
        return true;
      }

      return !this.formData.id;
    },
    isUpdating() {
      if(!this.formData) {
        return false;
      }
      return !this.formData.id;
    },
  },
  methods: {
    save() {
      this.isSaving = true;
      let save = this.form.id ? this.update : this.create;

      return this.validationPromise()
      .then((stuffs) => {
        return save().then((response) => {
          this.validationErrors = {}
          this.$emit('saved', response.data);
          return response;
        })
      })
      .catch((error) => {
        if (!error.response) throw error;

        if (error.response.status === 422) this.validationErrors = error.response.data.errors
        this.$emit('error', this.validationErrors);

        throw error;
      })
      .finally((response) => {
        this.isSaving = false
        return response;
      })
    },
    validate() {
      let errors = {};

      // if (true) {
      //   errors.acceptable_time = ['acceptable_time is required if.'];
      // }

      return errors;
    },
    validationPromise() {
      return new Promise((resolve, reject) => {
        let validationErrors = this.validate();
        let isEmpty = Object.keys(validationErrors).length === 0;

        if (isEmpty) {
          resolve();
        } else {
          reject(this.buildValidationErrors(validationErrors));
        }
      });
    },
    buildValidationErrors(errors) {
      return {
        response: {
          status: 422,
          data: {
            message: 'Client Validation Failed',
            errors: errors,
          }
        }
      }
    },
  },
}

